export { default } from './InputLabel';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/InputLabel/index.js
// module id = 548
// module chunks = 2